import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';

@Component({
    selector: 'app-logout-dialog',
    templateUrl: './logout-dialog.component.html',
    styleUrls: ['./logout-dialog.component.scss']
})
export class LogoutDialogComponent implements OnInit {
    constructor(
        private userAuthService: UserAuthService,
        public dialogRef: MatDialogRef<LogoutDialogComponent>
    ) {}

    ngOnInit() {}
    logout() {
        this.userAuthService.logout();
    }

    cancel() {
        this.dialogRef.close();
    }
}
